import { PermissionRequirement } from './permission.model';

export const TEAM_USER_PERMISSIONS = {
  list: { resource: 'users', action: 'index' },
  create: { resource: 'users', action: 'create' },
  update: { resource: 'users', action: 'update' },
  destroy: { resource: 'users', action: 'destroy' },
} as const satisfies Record<string, PermissionRequirement>;

export const TEAM_ROLE_PERMISSIONS = {
  list: { resource: 'roles', action: 'index' },
  update: { resource: 'roles', action: 'update' },
} as const satisfies Record<string, PermissionRequirement>;
